import { useQuery } from "@tanstack/react-query";
import { MessageInfo } from "@42maru/webchat";
import conversationRepository from "@/repository/conversationRepository";


interface UseSearchedMessagesProps {
    scenarioId: string;
    conversationId: string;
    senderType?: string;
    condition?: string;
}

const getData = async (props: UseSearchedMessagesProps) => {
    const { scenarioId, conversationId, senderType, condition } = props;
    if (!senderType || !condition) {
        return [];
    }
    const res = await conversationRepository.searchMessages(scenarioId, conversationId, senderType, condition);
    return res.data || [];
};

export const useSearchedMessages = ({
    scenarioId,
    conversationId,
    senderType,
    condition
}: UseSearchedMessagesProps) => {
    return useQuery<MessageInfo[]>({
        queryKey: ["messages", "search", scenarioId, conversationId, senderType, condition],
        queryFn: () => getData({ scenarioId, conversationId, senderType, condition })
    });
}; 